import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './SkeletonLine.st.css.js';
import { DEFAULT_WIDTH, HEIGHT } from './constants';
import { DEFAULT_SKIN } from '../SkeletonGroup/SkeletonGroup.constants';
import Box from '../Box';
import { SkeletonGroupContext } from '../SkeletonGroup';
const SkeletonLine = ({ dataHook, className, width = DEFAULT_WIDTH, margin, marginLeft, marginRight, marginTop, marginBottom, }) => {
    return (React.createElement(SkeletonGroupContext.Consumer, null, context => {
        const skin = (context && context.skin) || DEFAULT_SKIN;
        return (React.createElement("div", { "data-hook": dataHook, className: className, "data-width": width, "data-skin": skin },
            React.createElement(Box, { height: HEIGHT, width: width, margin: margin, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, marginBottom: marginBottom, className: st(classes.root, { skin }) })));
    }));
};
SkeletonLine.displayName = 'SkeletonLine';
SkeletonLine.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default SkeletonLine;
//# sourceMappingURL=SkeletonLine.js.map